export default __webpack_public_path__ + "static/media/StatusArrow.fb5ffa1a.svg";